import { ActionTypes } from 'redux/utils/Details'

export default ActionTypes('REFERRAL_REQUEST')